/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import * as actions from './action'
import Standby from './component/standby'

class ClubStandby extends React.Component {
  static defaultProps = {
    standbyList: {
      list: [],
    },
    period: {
      start_time: moment().format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
  }

  render() {
    const { standbyList, period } = this.props
    return (
      <Standby
        period={period}
        standbyList={standbyList}
        fetchSearchStandby={this.props.fetchSearchStandby}
        getPeriod={this.props.getPeriod}
        fetchTimePeriod={this.props.fetchTimePeriod}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    standbyList: state.getClubStandby.standbyList,
    period: state.getClubStandby.period,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubStandby))



// WEBPACK FOOTER //
// ./src/containers/ClubStandby/index.js